<template>
  <div>
    <h2 class="content-heading">
      <button type="button" class="btn btn-sm btn-success btn-noborder float-right"  @click="openCreateUserModal">
        <i class="fa fa-plus mr-5"></i>Nieuwe Gebruiker
      </button>
      <i class="si si-people mr-5"></i> Gebruikers
    </h2>

    <div class="row">
    <div class="col-md-6 col-xl-3" v-for="user in users" :key="user.id">
    <div class="block block-link-shadow text-center">
    <div class="block-content block-content-full block-sticky-options pt-30">
      <div class="block-options">
        <b-dropdown class="dropdown-no-btn" right>
          <template slot="button-content">
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item @click="openHourRegistrationModal(user.id)" v-if="user.role === 'orderpicker'">
            <i class="si si-clock mr-5"></i>Bekijk uren registratie
          </b-dropdown-item>
          <b-dropdown-item  @click="deleteUser(user.id)">
            <i class="fa fa-exclamation-circle mr-5"></i>Verwijder gebruiker
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <img class="img-avatar" :src="user.avatar_url" alt="">
    </div>
    <div class="block-content block-content-full block-content-sm bg-body-light">
      <div class="font-w600 mb-5">{{user.username}}</div>
    </div>
    <div class="block-content">
      <div class="row items-push text-center">
        <div class="col-6">
          <div class="mb-5"><i class="si si-badge fa-2x"></i></div>
          <div class="font-size-sm text-muted">{{user.role}}</div>
        </div>
        <div class="col-6">
          <div class="mb-5"><i class="si si-user-follow fa-2x"></i></div>
          <div class="font-size-sm text-muted">{{user.created_at | moment('calendar')}}</div>
        </div>
      </div>
    </div>
  </div>
      </div>
    </div>
    <create-new-user-modal v-if="showCreateUserModal" @userCreated="loadUsers" @close="showCreateUserModal = false" ></create-new-user-modal>
    <hour-registration-modal v-if="showHourRegistrationModal" :userId="selectedUserId"  @close="showHourRegistrationModal = false" ></hour-registration-modal>
  </div>
</template>

<script>
import http from '../utils/http'
import CreateNewUserModal from './CreateNewUserModal'
import HourRegistrationModal from './HourRegistrationModal.vue'

export default {
  components: {
    CreateNewUserModal,
    HourRegistrationModal
  },
  data () {
    return {
      users: [],
      showCreateUserModal: false,
      showHourRegistrationModal: false,
      selectedUserId: null
    }
  },
  methods: {
    loadUsers () {
      const params = {
        'filter[role]': 'orderpicker'
      }

      http.get('/users', { params })
      .then((response) => {
        this.users = response.data.data
      })
      .catch(() => {
        this.$swal('Oeps! 😳', 'Er is iets fout gegaan bij het ophalen van de gebruikers. Probeer het opnieuw.', 'error')
      })
    },
    openCreateUserModal () {
      this.showCreateUserModal = true
    },
    openHourRegistrationModal (id) {
      this.selectedUserId = id
      this.showHourRegistrationModal = true
    },
    deleteUser (id) {
      http.delete(`/users/${id}`)
        .then((result) => {
          this.$swal('Hoera 😊', `Gebruiker is verwijderd.`, 'success')
          this.loadUsers()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het verwijderen van de gebruiker', 'warning')
        })
    }
  },
  created () {
    this.loadUsers()
  }
}
</script>



// WEBPACK FOOTER //
// UsersPage.vue?335a4636